<template>
  <vs-sidebar
    default-index="1"
    :parent="parent"
    :hiddenBackground="$store.getters['IS_SIDEBAR_ACTIVE']"
    class="sidebarx"
    spacer
    v-model="$store.getters['IS_SIDEBAR_ACTIVE']"
    :click-not-close="$store.getters['IS_SIDEBAR_ACTIVE']"
  >
    <vs-sidebar-item :to="'/overview'" index="1" icon="cloud_queue">
      Overview
    </vs-sidebar-item>
    <vs-sidebar-item :to="'/hino/report-data'" index="2" icon="description" v-if="username == 'hinoIT' || username == 'hinoOT'">
      Report
    </vs-sidebar-item>
    <vs-sidebar-item :to="'/Alert'" index="2.3" icon="report_problem">
      Alert
    </vs-sidebar-item>

    <vs-sidebar-group open title="Dashboard">
      <vs-sidebar-group open title="Hino Fac.3">
        <!-- <vs-sidebar-item :to="'/EngineAssemblyLine'" index="2.1">
          <img
            style="width: 13.5%; height: 13.5%"
            src="@/assets/images/hino element/icon_sidebar/5.png"
          />
          Engine Assembly Line
        </vs-sidebar-item>
        <vs-sidebar-item :to="'/ConeveyerLine'" index="2.1">
          <img
            style="width: 13.5%; height: 13.5%"
            src="@/assets/images/hino element/icon_sidebar/3.png"
          />
          Coneveyer Line
        </vs-sidebar-item> -->

     
         <vs-sidebar-group  title="Differential Line">
          <vs-sidebar-item v-for="i in 1"  :key="i"  :to="'/EngineAssemblyLine'"  index="2.1">
            <img
              style="width: 13.5%; height: 13.5%"
              src="@/assets/images/hino element/icon_sidebar/6.png"
            />
            Machine {{i}}
          </vs-sidebar-item>
         
        </vs-sidebar-group>
            <vs-sidebar-group  title="Final Assembly Line">
          <vs-sidebar-item v-for="i in 1"  :key="i"  :to="'/ConeveyerLine'"  index="2.1">
            <img
              style="width: 13.5%; height: 13.5%"
              src="@/assets/images/hino element/icon_sidebar/6.png"
            />
            Machine {{i}}
          </vs-sidebar-item>
         
        </vs-sidebar-group>
        <vs-sidebar-group  title="Body Line">
          <vs-sidebar-item v-for="i in 5"  :key="i"  :to="'/bodyOutLine/'+i"  index="2.1">
            <img
              style="width: 13.5%; height: 13.5%"
              src="@/assets/images/hino element/icon_sidebar/6.png"
            />
            Machine {{i}}
          </vs-sidebar-item>
         
        </vs-sidebar-group>
      </vs-sidebar-group>
    </vs-sidebar-group>
    <vs-sidebar-group title="Device Mangement">
      <vs-sidebar-item :to="'/sensor'" index="2.2" icon="settings_remote">
        Device
      </vs-sidebar-item>
      <vs-sidebar-item :to="'/gateway'" index="2.3" icon="router">
        Gateway
      </vs-sidebar-item>
    </vs-sidebar-group>
    <vs-sidebar-group title="Setting">
      <vs-sidebar-item :to="'/action'" index="2.1" icon="new_releases">
        Alert Setting
      </vs-sidebar-item>
      <vs-sidebar-item :to="'/network'" index="2.2" icon="wifi">
        Network
      </vs-sidebar-item>
      <vs-sidebar-item :to="'/user'" index="2.3" icon="person" v-if="username == 'hinoIT' || username == 'hinoOT'">
        User
      </vs-sidebar-item>
    </vs-sidebar-group>

    <footer-sidebar slot="footer"> 
      <!-- <div class="footer-sidebar center">
        <div style="margin: 8px; text-align: center">
          <h5
            style="font-size: 0.8rem; font-weight: 550; color: rgb(91, 87, 119)"
          >
            <img
              class="ml-1"
              src="@/assets/images/ex_banner2.png"
              style="width: 100%"
            />
          </h5>
        </div>
      </div> -->
    </footer-sidebar>
  </vs-sidebar>
</template>

<script>
import FooterSidebar from "../FooterSidebar.vue";
export default {
  name: "BetagroSidebar",
  components: {
    FooterSidebar,
  },
  data() {
    return {
      list_route: [
        "/overview",
        "/dataExport",
        "/EngineAssemblyLine",
        "/ConeveyerLine",
        "/BodyOutLine",
        "/sensor",
        "/gateway",
        "/network",
      ],
      interval: null,
      username: null,
    };
  },
  mounted() {
    this.username = this.$session.get('username')
    // let current_route = this.$route.path
    // console.log(current_route);
    // console.log(this.list_route.indexOf(current_route));
    // let i = this.list_route.indexOf(current_route) + 1
    // this.interval = setInterval(() => {
    //   console.log('push',this.list_route[i]);
    //   this.$router.push({ path: this.list_route[i] })
    //   i++
    //   if (i >= this.list_route.length) {
    //     i = 0
    //   }
    // },1000*10)
  },
  // beforeDestroy(){
  //   clearInterval(this.interval)
  // },
};
</script>

<style>
</style>